<template>
  <modal :name="name" :clickToClose="false" :delay="100" :width="450" classes="modalBoon" transition="nice-modal-fade">
    <h2 v-if="title">{{ title }}</h2>

    <p v-if="description">{{ description }}</p>

    <p class="d-flex flex-column mt-4">
      <span>{{ $t('Email address to send email to') }}</span>
      <input v-model="innerEmail" />
    </p>

    <ul class="modalButtons">
      <li>
        <button :disabled="!isEmailValid" class="darkButton" @click="onConfirmClick">{{ $t('Send email') }}</button>
      </li>
      <li>
        <button class="lightButton" @click="onCancelClick">{{ $t("Don't mail") }}</button>
      </li>
    </ul>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MailDialog',

  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    project: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      innerEmail: null,
    };
  },

  computed: {
    ...mapGetters(['getPersonById']),

    isEmailValid() {
      return !!this.innerEmail;
    },

    siteManagerEmail() {
      if (!this.project || !this.project.projectManagers) {
        return null;
      }

      /** @todo Crazy stuff. Need to normalize occupations */
      const occupations = ['Site Manager', this.$t('Site Manager'), 'Site manager', this.$t('Site manager')];
      const siteManager = this.project.projectManagers.find(({ occupation }) => occupations.includes(occupation));
      const person = siteManager && siteManager.personId && this.getPersonById(siteManager.personId);

      return (person && person.email) || null;
    },

    companyEmail() {
      return (this.company && this.company.email) || null;
    },

    defaultEmail() {
      return this.siteManagerEmail || this.companyEmail;
    },
  },

  watch: {
    defaultEmail: {
      immediate: true,
      handler(next) {
        this.innerEmail = next;
      },
    },
  },

  methods: {
    onConfirmClick() {
      this.$emit('confirm', this.innerEmail);
    },

    onCancelClick() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: 'DIN Alternate Bold';
  /* src: url('location.eot'); */
  src:
      /* url('location.eot#iefix') format('embedded-opentype'), */ url('/static/fonts/DINAlternate-Bold.woff')
      format('woff'),
    url('/static/fonts/DINAlternate-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'DIN-Light';
  src: url('/static/fonts/DINLight.woff') format('woff'); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/EditCompany/CompanyFiles/MailDialog/index.vue